import React, {Component} from 'react';
import './Announcement.css';
import AnnouncementBlock from "./AnnouncementBlock";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";

class AnnouncementMainPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentUser: this.props.currentUser,
            userAnnouncements:[],
        };
        this.listUserAnnouncements=this.listUserAnnouncements.bind(this);
    }

    componentDidMount() {
        this.listUserAnnouncements();
    }

    listUserAnnouncements() {
        let self = this;
        //let userId=this.state.currentUser.id;
        let params = {
            url: API_BASE_URL+"/announcement/forUser" ,
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                let userAnnouncements = response.data;
                self.setState({
                    userAnnouncements,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        return (
            <div className="announcement-block-item-container">
                <div className="row">
                    <AnnouncementBlock inputAnnouncementList={this.state.userAnnouncements}/>
                </div>
            </div>
        );
    }
}

export default AnnouncementMainPage;


// WEBPACK FOOTER //
// ./src/page/announcement/AnnouncementMainPage.js